module.exports = __webpack_public_path__ + "media/images/masks/avatar-status-c2f8f473dd9ea85cf19302081c9d6ae62a1187bb031113544020b941e94b3d4b.svg";